export const InvictusFaqList = [
    {
        targetId: '1',
        heading: 'Q. What is INVICTUS ACE Test ?',
        subheading: 'INVICTUS ACE Test is a unique initiative by AAKASH, crafted to help students identify their current strengths, weaknesses, opportunities, and threats (SWOT), and gain clarity on their future path. It also provides a platform for students to showcase their hidden potential and earn exciting rewards.',
        bulletpoints: [],
    },
    {
        targetId: '2',
        heading: 'Q. What is the eligibility criteria for the Invictus ACE exam?',
        subheading: 'There is no specific eligibility criteria for the INVICTUS ACE program; it is open to all students currently studying in Grades 8th to 12th.',
        bulletpoints: [],
    },
    {
        targetId: '3',
        heading: 'Q. How and when will the Test be conducted?',
        bulletpoints: [],
        subheading: 'INVICTUS ACE Test will be conducted in both offline mode and online mode. The test dates will be <strong>24th Aug , 31st Aug  & 7th Sep 2025.</strong>',
    },
    {
        targetId: '4',
        heading:
            'Q. What are the Test timings for the INVICTUS ACE Test?',
        bulletpoints: [],
        subheading: 'The INVICTUS ACE Test will be held from 10:00 AM to 1:00 PM for Offline and 10:00 AM to 10:00 PM online modes.',
    },
    {
        targetId: '5',
        heading: 'Q. How to Apply for INVICTUS ACE ?',
        bulletpoints: [],
        subheading: '<strong>For Online Registration:</strong><br/><ol><li>Visit: <a href="https://www.aakash.ac.in/invictus-ace" style="color:#0000FF">https://www.aakash.ac.in/invictus-ace</a></li><li>Enter your mobile number and verify via OTP, or use your PSID to register.</li><li>Fill in the required details such as name, contact number, class, stream, Test mode, etc.</li><li>Select your preferred Test date and time.</li><li>Make the payment and submit the form.</li></ol><strong>For Offline Registration:</strong><ol><li>Visit your nearest Aakash Centre.</li><li>Collect the INVICTUS ACE registration form from the center.</li><li>Fill out the form carefully, providing all required details.</li><li>Submit the completed form at the center.</li></ol>',
    },
    {
        targetId: '6',
        heading: 'Q. What is the Fees for the INVICTUS ACE Test?',
        subheading: 'The fee for INVICTUS ACE Test is ₹300, and it remains the same for both online and offline modes.',
        bulletpoints: [],
    },
    {
        targetId: '7',
        heading: 'Q. What is the last Date of Registration?',
        subheading: '<strong>The last date for registration for INVICTUS ACE is:</strong><ul><li>Offline mode: 2 days before the test date</li><li>	Online mode: 2 days before the test date</li></ul>',
        bulletpoints: [],
    },
    {
        targetId: '8',
        heading: 'Q. When will I receive the result of the test ?',
        subheading: '<table style="width: 45%;text-align: center;"><tr><td><strong>Test Date<strong></td><td><strong>Result Declaration Date</strong></td></tr><tr><td>24th August 2025</td><td>30th August 2025</td></tr><tr><td>31st August 2025</td><td>6th September 2025</td></tr><tr><td>7th September 2025</td><td>13th September 2025</td></tr></table>',
        bulletpoints: [],
    },
    {
        targetId: '9',
        heading: 'Q. Are there any practice tests available for Invictus ACE preparation?',
        subheading: 'Yes, a sample test for INVICTUS ACE is provided and will be shared via SMS/Email after registration.',
        bulletpoints: [],
    },
    {
        targetId: '10',
        heading: 'Q. How can I Get more information about the Test?',
        subheading: 'For more information, please call us at 1800-102-2727 or email us at <a href="mailto:invictusacesupport@aesl.in" style="color:#0000FF">invictusacesupport@aesl.in</a>.',
        bulletpoints: [],
    },
    {
        targetId: '11',
        heading: 'Q. What is the Test pattern and syllabus for the INVICTUS ACE Test?',
        subheading: 'Please Referred to the Brochure - <a href="https://bit.ly/invictus-ace-brochure" style="color:#0000FF">https://bit.ly/invictus-ace-brochure</a>',
        bulletpoints: [],
    },
]